import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '52 weekly classes', '5 Bonuses', 'Ages 3–12', 'Mixed levels', '30 · 45 · 60 min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print two pages, teach the class'];
const apparatus = [{
  name: 'Floor',
  color: 'bg-coral'
}, {
  name: 'Bars',
  color: 'bg-indigo'
}, {
  name: 'Beam',
  color: 'bg-teal'
}, {
  name: 'Vault',
  color: 'bg-amber'
}];
export function Hero() {
  return <section className="gym-floor relative w-full overflow-hidden text-white" data-id="element-118" data-mp="xbpawzbp5obv">
      <div className="lane-lines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-119" data-mp="sai3509k0p57" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-120" data-mp="ncq47mahs2ri">
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-x-14 lg:gap-y-6" data-id="element-121" data-mp="3d1sa6w93nhsl">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-122" data-mp="381e1rd3l65u1">
            <p className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.6px] text-white/80 sm:text-[11px]" data-id="element-123" data-mp="3j8ix6zga0gup">
              <span className="h-2 w-2 rounded-full bg-amber" aria-hidden="true" data-id="element-124" data-mp="39acwgl67hgrf" />
              Rec Gymnastics Class-Ready · for recreational coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[64px] xl:text-[70px]" data-id="element-125" data-mp="3e7l61xdagch2">
              Walk into every class{' '}
              <span className="mark-hl-dark" data-id="element-126" data-mp="35a2fkdgvl5xs">already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-127" data-mp="2qlogmdmky1mi">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/80 sm:text-base lg:text-lg" data-id="element-128" data-mp="2vi54r7ts4fzl">
              A full year of done-for-you rec gymnastics classes: 52 weekly plans
              across floor, bars, beam and vault, with every skill at three
              levels for your mixed group. No more Sundays spent planning. No
              more free-for-all.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-129" data-mp="nat8vfsf4smt">
              <CtaButton data-id="element-130" data-mp="n98ebq63t9oy">Get Rec Gymnastics Class-Ready</CtaButton>
            </div>
          </div>

          <div className="lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:self-center" data-id="element-131" data-mp="ia5jsznr2lv8">
            <ProductVisual className="w-[88%] max-w-[520px] sm:w-[80%] lg:w-[92%]" data-id="element-132" data-mp="deyj80ps1xaj" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-133" data-mp="1b04aezhler20">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-134" data-mp="161jc55lwihg7">
              <ul className="flex gap-1.5" aria-label="Every class covers four apparatus" data-id="element-135" data-mp="1126nqgfdt2bi">
                {apparatus.map(a => <li key={a.name} className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${a.color} ${a.name === 'Vault' ? 'text-ink' : 'text-white'}`} data-id="element-136" data-mp="x0l50eg61tte">
                    {a.name}
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/70" data-id="element-137" data-mp="21a4tjve00i5z">
                Built for <span className="font-semibold text-white" data-id="element-138" data-mp="269hbq2txd128">rec coaches teaching mixed-level classes</span>{' '}
                of kids 3–12 in the US, Canada, UK &amp; Australia
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-139" data-mp="2g0luzeqmv82v">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-140" data-mp="2kx2ic6q0diew">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-amber" data-id="element-141" data-mp="2p1jv3lxyavg6" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-142" data-mp="umzfvosefs46">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-143" data-mp="uokdxodx9t6s">
              {chips.map(chip => <li key={chip} className="rounded-full border border-white/15 bg-ink-deep/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-144" data-mp="znn8ug06uj11">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-145" data-mp="9b0bltpo9xzj" />
    </section>;
}